module.exports = __webpack_public_path__ + "assets/img/fr-bd3f7097.png";